
/**
* 花びらを舞わせる
*/

// 設定
import config from './config';
// グローバル変数
import valiable from './valiable';
// 花びらコントローラー
import SakuraControllerClass from './SakuraControllerClass';


export default function () {

    // ページごとの設定
    const page_config = config.PAGE_SETTINGS[config.PAGE_ACTIVE];

    // フレームディレイ用カウンタ
    let frame_count = 0;

    // canvasの入れ物
    const canvas_wrap = $(config.CANVAS_WRAP);

    // レンダー設定
    const renderer = PIXI.autoDetectRenderer(256, 256,
        {
            antialias: true,
            transparent: true,
            resolution: window.devicePixelRatio
        }
    );

    // コンテナ
    const container = new PIXI.Container();

    // 花びらコントローラー
    const sakura_ctrl = new SakuraControllerClass(container);

    // 画像を読み込んだら開始
    Object.keys(page_config.IMAGES).forEach((v, i, a) => {
        PIXI.loader.add(page_config.IMAGES[v]);
    });
    PIXI.loader.load(setup);

    /**
     * PIXI.loader が画像を読み込み終わったら実行
     */
    function setup() {
        // ウィンドウサイズ取得とレンダーサイズ変更
        valiable.win_width = canvas_wrap.width();
        valiable.win_height = canvas_wrap.height();

        // レンダー設定
        renderer.view.style.position = 'relative';
        renderer.view.style.top = 0;

        // キャンバス設定
        canvas_wrap.append(renderer.view);
        canvas_wrap.find('canvas').css({ pointerEvents: 'none' });

        // コンテナに画像を登録
        setup_screen();
        // イベントセットアップ
        setup_event();

        const test_sprite = new PIXI.Sprite(
            PIXI.loader.resources.sakura_1.texture);
        container.addChild(test_sprite);

        // 描画
        requestAnimationFrame(refresh_screen);
    }

    /**
    * 画像をセットアップ
    */
    function setup_screen() {
        // 奥の桜
        sakura_ctrl.setup("S");
        // 桜（中）
        sakura_ctrl.setup("M");
        // 手前の桜（大）
        sakura_ctrl.setup("L");
    }

    /** ******************************
    * イベントセットアップ
    */
    function setup_event() {
        $(window).resize($.throttle(60, resize_screen));
        resize_screen();
    }

    /** ******************************
    * 描画
    */
    function refresh_screen() {

        requestAnimationFrame(refresh_screen);

        // fpsを落とす
        frame_count += 1;
        if (frame_count % config.FRAME_DELAY !== 0) return;
        frame_count = 0;

        // 花びらの移動
        sakura_ctrl.fall();

        // 描画
        renderer.render(container);
    }

    /** ******************************
    * ウィンドウリサイズ
    */
    function resize_screen() {

        // ウィンドウサイズ取得とレンダーサイズ変更
        valiable.win_width = canvas_wrap.width();
        valiable.win_height = canvas_wrap.height();

        // レンダーサイズ変更
        renderer.resize(valiable.win_width, valiable.win_height);

        // 花びらの再配置
        sakura_ctrl.attach_random();
    }
}



// WEBPACK FOOTER //
// ./js/module/flower/flower.js